/** Deterministic initials avatars. WhatsApp's Cloud API does not expose customers'
 *  profile photos (privacy: only the business's own profile is readable), so the
 *  panel renders initials on a stable per-contact colour instead of a grey glyph. */

/** Up to two initials from a display name; null when there's nothing usable. */
export function initialsFor(name: string | null | undefined): string | null {
  const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return null;
  const first = [...(words[0] as string)][0] ?? "";
  const second = words.length > 1 ? ([...(words[words.length - 1] as string)][0] ?? "") : "";
  const initials = `${first}${second}`.toUpperCase();
  // Skip pure punctuation/emoji-soup names — the glyph fallback reads better.
  return /\p{L}|\p{N}/u.test(initials) ? initials : null;
}

/** Stable hue (0-359) from any per-contact key (phone works well). */
export function hueFor(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return h % 360;
}

/** Inline style for an initials avatar — readable on both themes. */
export function avatarStyle(seed: string): { background: string; color: string } {
  return { background: `oklch(0.46 0.09 ${hueFor(seed)})`, color: "oklch(0.97 0.005 250)" };
}
